(function () {
  var MAX_IMAGE_SIZE = 1600;
  var PROOF_WIDTH = 620;
  var PROOF_QUALITY = 0.72;
  var PRODUCT_FORM_SELECTOR = 'form[data-type="add-to-cart-form"]';
  var PROPERTY_PREFIX = 'properties[';
  var PROPERTY_SUFFIX = ']';
  var DEFAULT_PLACEMENT = {
    x: 0.5,
    y: 0.45,
    scale: 0.62,
    rotation: 0,
  };
  var DEFAULT_GARMENT_PROFILE = {
    name: 'Custom tee',
    maxPrintWidth: 14,
    maxPrintHeight: 16,
    front: { x: 0.27, y: 0.18, width: 0.46, height: 0.62 },
    back: { x: 0.27, y: 0.16, width: 0.46, height: 0.64 },
  };
  var GARMENT_PROFILES = {
    'custom-print-short-sleeve-tee-black': {
      name: 'Comfort Colors 1717',
      maxPrintWidth: 14,
      maxPrintHeight: 16,
      front: { x: 0.28, y: 0.2, width: 0.44, height: 0.59 },
      back: { x: 0.28, y: 0.17, width: 0.44, height: 0.63 },
    },
    'custom-print-as-colour-box-tee-5030': {
      name: 'AS Colour Box Tee 5030',
      maxPrintWidth: 14,
      maxPrintHeight: 16,
      front: { x: 0.26, y: 0.19, width: 0.48, height: 0.61 },
      back: { x: 0.26, y: 0.17, width: 0.48, height: 0.64 },
    },
    'custom-print-sma-m1200': {
      name: 'Smart Blanks M1200',
      maxPrintWidth: 14,
      maxPrintHeight: 16,
      front: { x: 0.27, y: 0.2, width: 0.46, height: 0.6 },
      back: { x: 0.27, y: 0.18, width: 0.46, height: 0.62 },
    },
    'custom-print-elwood-oversized-core-tee': {
      name: 'Elwood Oversized Core Tee',
      maxPrintWidth: 14,
      maxPrintHeight: 16,
      front: { x: 0.25, y: 0.19, width: 0.5, height: 0.61 },
      back: { x: 0.25, y: 0.17, width: 0.5, height: 0.64 },
    },
  };

  function clamp(value, min, max) {
    return Math.max(min, Math.min(max, value));
  }

  function readFileAsDataUrl(file) {
    return new Promise(function (resolve, reject) {
      var reader = new FileReader();
      reader.onload = function () {
        resolve(reader.result);
      };
      reader.onerror = reject;
      reader.readAsDataURL(file);
    });
  }

  function loadImage(src) {
    return new Promise(function (resolve, reject) {
      var image = new Image();
      image.onload = function () {
        resolve(image);
      };
      image.onerror = reject;
      if (/^(https?:)?\/\//i.test(src)) image.crossOrigin = 'anonymous';
      image.src = src;
    });
  }

  function dataUrlToBlob(dataUrl) {
    return fetch(dataUrl).then(function (response) {
      if (!response.ok) throw new Error('Could not prepare the placement proof.');
      return response.blob();
    });
  }

  function getProofUploadPublicKey() {
    return window.UploadKit && window.UploadKit.config ? window.UploadKit.config.ucKey || '' : '';
  }

  function uploadProof(dataUrl, fileName, setupId, side) {
    var publicKey = getProofUploadPublicKey();

    if (!dataUrl) return Promise.resolve('');
    if (!publicKey) return Promise.reject(new Error('The proof upload service is not ready. Please try again.'));

    return dataUrlToBlob(dataUrl)
      .then(function (blob) {
        var uploadData = new FormData();

        uploadData.append('UPLOADCARE_PUB_KEY', publicKey);
        uploadData.append('UPLOADCARE_STORE', 'auto');
        uploadData.append('metadata[claymore_setup_id]', setupId);
        uploadData.append('metadata[claymore_side]', side);
        uploadData.append('file', blob, fileName);
        return fetch('https://upload.uploadcare.com/base/', {
          method: 'POST',
          body: uploadData,
        });
      })
      .then(function (response) {
        if (!response.ok) throw new Error('The placement proof could not be uploaded.');
        return response.json();
      })
      .then(function (result) {
        var fileId = result && (result.file || result[fileName]);

        if (!fileId) throw new Error('The placement proof upload did not return a file.');
        return 'https://cdn.getuploadkit.com/' + fileId + '/';
      });
  }

  function resizeImage(image) {
    var ratio = Math.min(1, MAX_IMAGE_SIZE / Math.max(image.naturalWidth, image.naturalHeight));
    var width = Math.max(1, Math.round(image.naturalWidth * ratio));
    var height = Math.max(1, Math.round(image.naturalHeight * ratio));
    var canvas = document.createElement('canvas');
    var context = canvas.getContext('2d');

    canvas.width = width;
    canvas.height = height;
    context.drawImage(image, 0, 0, width, height);

    return {
      dataUrl: canvas.toDataURL('image/png'),
      width: width,
      height: height,
    };
  }

  function findProductForm() {
    return document.querySelector(PRODUCT_FORM_SELECTOR);
  }

  function setHiddenProperty(form, name, value) {
    var inputName = PROPERTY_PREFIX + name + PROPERTY_SUFFIX;
    var input = Array.prototype.slice.call(form.querySelectorAll('input')).find(function (field) {
      return field.name === inputName;
    });

    if (!input) {
      input = document.createElement('input');
      input.type = 'hidden';
      input.name = inputName;
      input.dataset.claymoreDesignerProperty = 'true';
      form.appendChild(input);
    }

    input.value = value || '';
  }

  function removeHiddenProperties(form) {
    form.querySelectorAll('[data-claymore-designer-property="true"]').forEach(function (input) {
      input.remove();
    });
  }

  function formatPlacement(state, side, garmentProfile) {
    var printArea = garmentProfile[side] || garmentProfile.front;

    return JSON.stringify({
      sourceFileName: state.fileName || '',
      sourceFileType: state.fileType || '',
      sourceFileSize: state.fileSize || 0,
      sourceImageWidth: state.sourceWidth || 0,
      sourceImageHeight: state.sourceHeight || 0,
      garment: {
        handle: garmentProfile.handle || '',
        name: garmentProfile.name || '',
        maximumPrintWidthInches: garmentProfile.maxPrintWidth,
        maximumPrintHeightInches: garmentProfile.maxPrintHeight,
      },
      printArea: {
        xPercent: Math.round(printArea.x * 1000) / 10,
        yPercent: Math.round(printArea.y * 1000) / 10,
        widthPercent: Math.round(printArea.width * 1000) / 10,
        heightPercent: Math.round(printArea.height * 1000) / 10,
      },
      placement: {
        xPercent: Math.round(state.x * 1000) / 10,
        yPercent: Math.round(state.y * 1000) / 10,
        scalePercent: Math.round(state.scale * 100),
        rotationDegrees: Math.round(state.rotation),
        estimatedWidthInches: Math.round(garmentProfile.maxPrintWidth * state.scale * 10) / 10,
      },
      side: side,
      note: 'Customer-created Claymore ' + side + ' placement proof. Use with the matching UploadKit artwork file.',
      createdAt: new Date().toISOString(),
    });
  }

  function createPlacementState(side) {
    return {
      side: side || 'front',
      shirtImage: null,
      image: null,
      fileName: '',
      fileType: '',
      fileSize: 0,
      sourceWidth: 0,
      sourceHeight: 0,
      x: DEFAULT_PLACEMENT.x,
      y: DEFAULT_PLACEMENT.y,
      scale: DEFAULT_PLACEMENT.scale,
      rotation: DEFAULT_PLACEMENT.rotation,
      proofDataUrl: '',
      printAreaPixels: null,
      isDarkGarment: null,
      uploadkitThumbnailSrc: '',
      uploadkitThumbnailRequestSrc: '',
      isDragging: false,
      isLocked: false,
    };
  }

  function getContainedImageRect(image, width, height) {
    var imageWidth = image && image.naturalWidth ? image.naturalWidth : width;
    var imageHeight = image && image.naturalHeight ? image.naturalHeight : height;
    var ratio = Math.min(width / imageWidth, height / imageHeight);
    var drawWidth = imageWidth * ratio;
    var drawHeight = imageHeight * ratio;

    return {
      x: (width - drawWidth) / 2,
      y: (height - drawHeight) / 2,
      width: drawWidth,
      height: drawHeight,
    };
  }

  function getPlacementArea(shirtRect, placementArea) {
    return {
      x: shirtRect.x + shirtRect.width * placementArea.x,
      y: shirtRect.y + shirtRect.height * placementArea.y,
      width: shirtRect.width * placementArea.width,
      height: shirtRect.height * placementArea.height,
    };
  }

  function isDarkPrintArea(context, printArea) {
    var sampleCanvas = document.createElement('canvas');
    var sampleContext;
    var pixels;
    var brightnessTotal = 0;
    var pixelCount = 0;
    var index;

    sampleCanvas.width = 24;
    sampleCanvas.height = 24;
    sampleContext = sampleCanvas.getContext('2d', { willReadFrequently: true });
    if (!sampleContext) return false;

    try {
      sampleContext.drawImage(
        context.canvas,
        printArea.x,
        printArea.y,
        printArea.width,
        printArea.height,
        0,
        0,
        sampleCanvas.width,
        sampleCanvas.height
      );
      pixels = sampleContext.getImageData(0, 0, sampleCanvas.width, sampleCanvas.height).data;
    } catch (error) {
      return false;
    }

    for (index = 0; index < pixels.length; index += 4) {
      if (pixels[index + 3] < 128) continue;
      brightnessTotal +=
        (pixels[index] * 0.2126 + pixels[index + 1] * 0.7152 + pixels[index + 2] * 0.0722) / 255;
      pixelCount += 1;
    }

    return pixelCount > 0 && brightnessTotal / pixelCount < 0.48;
  }

  function drawDesign(context, printArea, state) {
    var image = state.image;
    var drawWidth = printArea.width * state.scale;
    var drawHeight = drawWidth * (image.naturalHeight / image.naturalWidth);
    var centerX = printArea.x + printArea.width * state.x;
    var centerY = printArea.y + printArea.height * state.y;

    context.save();
    context.beginPath();
    context.rect(printArea.x, printArea.y, printArea.width, printArea.height);
    context.clip();
    context.translate(centerX, centerY);
    context.rotate((state.rotation * Math.PI) / 180);
    context.drawImage(image, -drawWidth / 2, -drawHeight / 2, drawWidth, drawHeight);
    context.restore();
  }

  function drawShirt(context, width, height, state, placementArea) {
    var shirtRect = {
      x: width * 0.05,
      y: height * 0.05,
      width: width * 0.9,
      height: height * 0.9,
    };

    context.save();
    context.fillStyle = '#ffffff';
    context.fillRect(0, 0, width, height);

    if (state.shirtImage) {
      shirtRect = getContainedImageRect(state.shirtImage, width, height);
      context.drawImage(state.shirtImage, shirtRect.x, shirtRect.y, shirtRect.width, shirtRect.height);
    } else {
      context.fillStyle = '#f7f7f7';
      context.strokeStyle = '#d7d7d7';
      context.lineWidth = 3;
      context.fillRect(shirtRect.x, shirtRect.y, shirtRect.width, shirtRect.height);
      context.strokeRect(shirtRect.x, shirtRect.y, shirtRect.width, shirtRect.height);
    }

    var printArea = getPlacementArea(shirtRect, placementArea);
    var guideIsLight;
    var guideLabel = 'MAX PRINT AREA';
    var guideLabelWidth;

    if (state.isDarkGarment === null) {
      state.isDarkGarment = state.shirtImage ? isDarkPrintArea(context, printArea) : false;
    }
    guideIsLight = state.isDarkGarment;
    context.canvas.dataset.claymoreGuideContrast = guideIsLight ? 'light-on-dark' : 'dark-on-light';

    context.strokeStyle = guideIsLight ? 'rgba(255, 255, 255, 0.88)' : 'rgba(125, 29, 37, 0.62)';
    context.setLineDash([12, 8]);
    context.lineWidth = 2;
    context.strokeRect(printArea.x, printArea.y, printArea.width, printArea.height);
    context.setLineDash([]);
    context.font = '700 16px sans-serif';
    context.textAlign = 'left';
    guideLabelWidth = context.measureText(guideLabel).width;
    context.fillStyle = guideIsLight ? 'rgba(16, 17, 20, 0.76)' : 'rgba(255, 255, 255, 0.82)';
    context.fillRect(printArea.x + 4, printArea.y + 5, guideLabelWidth + 12, 24);
    context.fillStyle = guideIsLight ? '#ffffff' : 'rgba(125, 29, 37, 0.92)';
    context.fillText(guideLabel, printArea.x + 10, printArea.y + 23);
    context.restore();

    if (state.image) drawDesign(context, printArea, state);
    return printArea;
  }

  function initDesigner(root) {
    (root || document).querySelectorAll('[data-claymore-mockup-preview]').forEach(function (designer) {
      if (designer.dataset.initialized === 'true') return;
      designer.dataset.initialized = 'true';

      var modal = designer.closest('[data-claymore-designer-modal]');
      var dialog = modal && modal.querySelector('[data-claymore-designer-dialog]');
      var uploadSlot = designer.querySelector('[data-claymore-uploadkit-slot]');
      var canvas = designer.querySelector('[data-claymore-designer-canvas]');
      var uploadName = designer.querySelector('[data-claymore-upload-name]');
      var qualityFeedback = designer.querySelector('[data-claymore-quality-feedback]');
      var uploadSummary = designer.querySelector('[data-claymore-upload-summary]');
      var placementTools = designer.querySelector('[data-claymore-placement-tools]');
      var placementSideLabel = designer.querySelector('[data-claymore-placement-side-label]');
      var dragStatus = designer.querySelector('[data-claymore-drag-status]');
      var shirtPreview = designer.querySelector('[data-claymore-shirt-preview]');
      var mobilePreviewSlot = designer.querySelector('[data-claymore-mobile-preview-slot]');
      var placementLockButton = designer.querySelector('[data-claymore-placement-lock]');
      var placementLockLabel = designer.querySelector('[data-claymore-placement-lock-label]');
      var quickScaleControl = designer.querySelector('[data-claymore-quick-scale]');
      var quickScaleValue = designer.querySelector('[data-claymore-quick-scale-value]');
      var scaleNudgeButtons = designer.querySelectorAll('[data-claymore-scale-nudge]');
      var status = modal && modal.querySelector('[data-claymore-designer-status]');
      var finishButton = modal && modal.querySelector('[data-claymore-finish]');
      var stageBackButton = modal && modal.querySelector('[data-claymore-stage-back]');
      var resetButton = designer.querySelector('[data-claymore-reset]');
      var startOverButton = designer.querySelector('[data-claymore-start-over]');
      var stagePanels = modal ? modal.querySelectorAll('[data-claymore-stage-panel]') : [];
      var stageButtons = modal ? modal.querySelectorAll('[data-claymore-stage-nav]') : [];
      var printModeButtons = designer.querySelectorAll('[data-claymore-print-mode]');
      var artworkCards = designer.querySelectorAll('[data-claymore-artwork-card]');
      var artworkSelectButtons = designer.querySelectorAll('[data-claymore-artwork-select]');
      var artworkActionButtons = designer.querySelectorAll('[data-claymore-artwork-action]');
      var artworkThumbnails = {
        front: designer.querySelector('[data-claymore-artwork-thumbnail="front"]'),
        back: designer.querySelector('[data-claymore-artwork-thumbnail="back"]'),
      };
      var artworkPlaceholders = {
        front: designer.querySelector('[data-claymore-artwork-placeholder="front"]'),
        back: designer.querySelector('[data-claymore-artwork-placeholder="back"]'),
      };
      var artworkFiles = {
        front: designer.querySelector('[data-claymore-artwork-file="front"]'),
        back: designer.querySelector('[data-claymore-artwork-file="back"]'),
      };
      var approvalInput = designer.querySelector('[data-claymore-approval]');
      var reviewFrontImage = designer.querySelector('[data-claymore-review-front]');
      var reviewFrontCard = designer.querySelector('[data-claymore-review-front-card]');
      var reviewBackImage = designer.querySelector('[data-claymore-review-back]');
      var reviewBackCard = designer.querySelector('[data-claymore-review-back-card]');
      var reviewProofs = designer.querySelector('.cm-designer-review-proofs');
      var reviewProduct = designer.querySelector('[data-claymore-review-product]');
      var reviewVariant = designer.querySelector('[data-claymore-review-variant]');
      var reviewQuantity = designer.querySelector('[data-claymore-review-quantity]');
      var reviewSides = designer.querySelector('[data-claymore-review-sides]');
      var previewCaption = designer.querySelector('[data-claymore-preview-caption]');
      var controlValues = {
        rotation: designer.querySelector('[data-claymore-control-value="rotation"]'),
        x: designer.querySelector('[data-claymore-control-value="x"]'),
        y: designer.querySelector('[data-claymore-control-value="y"]'),
      };
      var closeButtons = modal ? modal.querySelectorAll('[data-claymore-designer-close]') : [];
      var controls = {
        rotation: designer.querySelector('[data-claymore-control="rotation"]'),
        x: designer.querySelector('[data-claymore-control="x"]'),
        y: designer.querySelector('[data-claymore-control="y"]'),
      };
      var shirtSrc = designer.dataset.claymoreShirtSrc || '';
      var blackFrontSrc = designer.dataset.claymoreBlackFrontSrc || '';
      var whiteFrontSrc = designer.dataset.claymoreWhiteFrontSrc || '';
      var blackBackSrc = designer.dataset.claymoreBlackBackSrc || '';
      var whiteBackSrc = designer.dataset.claymoreWhiteBackSrc || '';
      var productHandle = designer.dataset.claymoreProductHandle || '';
      var productTitle = designer.dataset.claymoreProductTitle || 'Custom shirt';
      var backPreviewAvailable = designer.dataset.claymoreBackPreviewAvailable === 'true';
      var backPrintVariantId = designer.dataset.claymoreBackPrintVariantId || '';
      var backPrintPrice = designer.dataset.claymoreBackPrintPrice || '$3.00';
      var garmentProfile = Object.assign({}, GARMENT_PROFILES[productHandle] || DEFAULT_GARMENT_PROFILE, {
        handle: productHandle,
      });
      var context = canvas && canvas.getContext('2d');
      var form = findProductForm();
      var submitButton = form && form.querySelector('[type="submit"][name="add"]');
      var allowSubmit = false;
      var returnFocus = null;
      var uploadKitBlock = null;
      var uploadMoveAttempts = 0;
      var uploadReadyTimer = null;
      var shirtImageRequest = 0;
      var isResettingUpload = false;
      var isSavingProofs = false;
      var frontState = createPlacementState('front');
      var backState = createPlacementState('back');
      var activeSide = 'front';
      var printMode = 'front';
      var workflowStage = 'upload';
      var state = frontState;
      var previewHome = shirtPreview && shirtPreview.parentNode;
      var previewHomeNextSibling = shirtPreview && shirtPreview.nextSibling;
      var mobilePreviewQuery = window.matchMedia('(max-width: 749px)');

      if (!modal || !canvas || !context || !form || !submitButton) return;

      function positionPreviewForViewport() {
        var useInlineMobilePreview = Boolean(
          shirtPreview && mobilePreviewQuery.matches && state.image && mobilePreviewSlot
        );

        if (useInlineMobilePreview) {
          if (shirtPreview.parentNode !== mobilePreviewSlot) mobilePreviewSlot.appendChild(shirtPreview);
        } else if (shirtPreview && previewHome && shirtPreview.parentNode !== previewHome) {
          previewHome.insertBefore(shirtPreview, previewHomeNextSibling);
        }
      }

      function syncPlacementLock() {
        var hasArtwork = Boolean(state.image);
        var isLocked = Boolean(hasArtwork && state.isLocked);

        if (!hasArtwork) state.isLocked = false;
        canvas.classList.toggle('is-placement-locked', isLocked);
        canvas.setAttribute(
          'aria-label',
          hasArtwork
            ? isLocked
              ? 'Artwork placement locked. Unlock placement to drag the artwork.'
              : 'Drag artwork to adjust its placement.'
            : 'Custom shirt artwork preview.'
        );

        if (placementLockButton) {
          placementLockButton.disabled = !hasArtwork;
          placementLockButton.classList.toggle('is-locked', isLocked);
          placementLockButton.setAttribute('aria-pressed', String(isLocked));
          placementLockButton.setAttribute(
            'aria-label',
            isLocked ? 'Unlock artwork placement' : 'Lock artwork placement'
          );
        }
        if (placementLockLabel) placementLockLabel.textContent = isLocked ? 'Unlock placement' : 'Lock placement';
        if (dragStatus) dragStatus.textContent = isLocked ? 'Locked · scroll enabled' : 'Drag on shirt';

        if (quickScaleControl) quickScaleControl.disabled = isLocked || !hasArtwork;
        scaleNudgeButtons.forEach(function (button) {
          button.disabled = isLocked || !hasArtwork;
        });
        Object.keys(controls).forEach(function (key) {
          if (controls[key]) controls[key].disabled = isLocked || !hasArtwork;
        });
        if (resetButton) resetButton.disabled = isLocked || !hasArtwork;
      }

      function setStatus(message, isError) {
        if (!status) return;
        status.textContent = message || '';
        status.classList.toggle('is-error', Boolean(isError));
      }

      function getUploadedThumbnails() {
        if (!uploadKitBlock) return [];
        return Array.prototype.slice.call(
          uploadKitBlock.querySelectorAll('.uploadkit-thumbnails img.uploadkit-thumbnail, .uploadkit-thumbnails img')
        );
      }

      function getCompletedUploadCount() {
        var remoteThumbnails = getUploadedThumbnails().filter(function (thumbnail) {
          var src = thumbnail.currentSrc || thumbnail.src || '';
          return /^(https?:)?\/\//i.test(src);
        });
        var uploadedUrls = [];

        if (!uploadKitBlock) return 0;
        uploadKitBlock.querySelectorAll('input[type="hidden"][value]').forEach(function (input) {
          var matches = String(input.value || '').match(/https?:\/\/[^\s"'\],]+/gi);
          if (matches) uploadedUrls = uploadedUrls.concat(matches);
        });

        return Math.max(remoteThumbnails.length, new Set(uploadedUrls).size);
      }

      function getAutomatedUploadKitNote() {
        return (
          'Placement configured in the Claymore artwork tool (' +
          (printMode === 'both' ? 'front and back' : printMode === 'back' ? 'back only' : 'front only') +
          '). Use the saved placement proof and order metadata.'
        );
      }

      function setUploadKitNoteValue(field, value) {
        var prototype;
        var valueSetter;

        if (!field || field.value === value) return;
        prototype = field.tagName === 'TEXTAREA' ? window.HTMLTextAreaElement.prototype : window.HTMLInputElement.prototype;
        valueSetter = Object.getOwnPropertyDescriptor(prototype, 'value');
        if (valueSetter && valueSetter.set) valueSetter.set.call(field, value);
        else field.value = value;
        field.dispatchEvent(new Event('input', { bubbles: true }));
        field.dispatchEvent(new Event('change', { bubbles: true }));
      }

      function prepareUploadKitNotes() {
        var automatedNote = getAutomatedUploadKitNote();

        if (!uploadKitBlock) return;
        uploadKitBlock.querySelectorAll('textarea, input[name*="note" i], input[placeholder*="note" i]').forEach(function (field) {
          field.disabled = false;
          field.required = false;
          field.removeAttribute('required');
          field.setAttribute('aria-hidden', 'true');
          field.tabIndex = -1;
          setUploadKitNoteValue(field, automatedNote);
          var wrapper = field.closest('.uploadkit-attribute, .uploadkit-form-field, .field') || field.parentElement;
          if (wrapper) wrapper.classList.add('cm-uploadkit-note-hidden');
        });
        uploadKitBlock.querySelectorAll('label, legend').forEach(function (label) {
          if (!/^notes?\s*:?$/i.test(label.textContent.trim())) return;
          label.classList.add('cm-uploadkit-note-hidden');
          var wrapper = label.closest('.uploadkit-attribute, .uploadkit-form-field, .field');
          if (wrapper) {
            wrapper.classList.add('cm-uploadkit-note-hidden');
            wrapper.querySelectorAll('input, textarea').forEach(function (field) {
              field.disabled = false;
              field.required = false;
              field.removeAttribute('required');
              field.setAttribute('aria-hidden', 'true');
              field.tabIndex = -1;
              setUploadKitNoteValue(field, automatedNote);
            });
          }
        });
      }

      function modeIncludesSide(side) {
        return printMode === side || printMode === 'both';
      }

      function isTwoSided() {
        return printMode === 'both';
      }

      function getUploadIndex(side) {
        if (!modeIncludesSide(side)) return -1;
        if (printMode === 'back') return side === 'back' ? 0 : -1;
        if (printMode === 'both') return side === 'back' ? 1 : 0;
        return side === 'front' ? 0 : -1;
      }

      function isUploadReady(side) {
        var sideState = side === 'back' ? backState : frontState;
        var uploadIndex = getUploadIndex(side);
        var requiredUploads = uploadIndex + 1;
        var completedUploads = getCompletedUploadCount();
        var formValid = !form.classList.contains('uploadkit-invalid');

        if (uploadIndex < 0) return false;
        if (!sideState.image) return false;
        if (!uploadKitBlock) return false;
        if (completedUploads >= requiredUploads) {
          return true;
        }

        var uploadButton = uploadKitBlock.querySelector('.uploadkit-button');
        var uploadButtonText = uploadButton ? uploadButton.textContent.trim() : '';
        var uploadedThumbnail = uploadKitBlock.querySelector('.uploadkit-thumbnails img, img[src]');
        var uploader = uploadKitBlock.querySelector('.uploadkit-uploader');
        var uploaderMarkedValid = uploader && !uploader.hasAttribute('invalid');

        if (uploadIndex > 0) return false;
        return Boolean(
          formValid &&
            (/change image|replace image|remove image/i.test(uploadButtonText) || uploadedThumbnail || uploaderMarkedValid)
        );
      }

      function requiredUploadsReady() {
        return (
          (!modeIncludesSide('front') || isUploadReady('front')) &&
          (!modeIncludesSide('back') || isUploadReady('back'))
        );
      }

      function requiredArtworkLoaded() {
        return (
          (!modeIncludesSide('front') || Boolean(frontState.image)) &&
          (!modeIncludesSide('back') || Boolean(backState.image))
        );
      }

      function updateFinishState() {
        var uploadsReady = requiredUploadsReady();
        var ready = workflowStage === 'review' ? uploadsReady : requiredArtworkLoaded();
        var approved = approvalInput ? approvalInput.checked : true;

        if (!finishButton) return;
        finishButton.disabled = !ready || isSavingProofs || (workflowStage === 'review' && !approved);
        if (isSavingProofs) {
          finishButton.textContent = 'Saving placement ' + (isTwoSided() ? 'proofs' : 'proof') + '...';
        } else if (workflowStage === 'upload') {
          finishButton.textContent = 'Review placement';
        } else {
          finishButton.textContent = 'Add configured shirt to cart';
        }
        if (startOverButton) startOverButton.hidden = !frontState.image && !backState.image;

        if (uploadsReady && uploadReadyTimer) {
          window.clearInterval(uploadReadyTimer);
          uploadReadyTimer = null;
        }
        if (uploadsReady && status && /secure upload finishes|still uploading/i.test(status.textContent)) {
          setStatus('Artwork uploaded. Review the placement when you are ready.', false);
        }
      }

      function watchForUploadCompletion() {
        var checks = 0;

        if (uploadReadyTimer) window.clearInterval(uploadReadyTimer);
        uploadReadyTimer = window.setInterval(function () {
          checks += 1;
          updateFinishState();
          if (checks >= 300 && uploadReadyTimer) {
            window.clearInterval(uploadReadyTimer);
            uploadReadyTimer = null;
          }
        }, 400);
      }

      function normalizeCompletedUpload() {
        prepareUploadKitNotes();
        if (!isUploadReady(activeSide)) return;
        form.classList.remove('uploadkit-invalid');
        document.querySelectorAll('.uploadkit-uploader[invalid]').forEach(function (uploader) {
          uploader.removeAttribute('invalid');
        });
      }

      function resetDesignerForNextItem() {
        if (uploadReadyTimer) {
          window.clearInterval(uploadReadyTimer);
          uploadReadyTimer = null;
        }

        isResettingUpload = true;
        removeHiddenProperties(form);
        frontState = createPlacementState('front');
        backState = createPlacementState('back');
        activeSide = 'front';
        printMode = 'front';
        state = frontState;
        workflowStage = 'upload';
        form.removeAttribute('data-claymore-back-print-variant-id');
        form.removeAttribute('data-claymore-setup-id');

        if (approvalInput) approvalInput.checked = false;
        if (reviewFrontImage) reviewFrontImage.removeAttribute('src');
        if (reviewFrontCard) reviewFrontCard.hidden = false;
        if (reviewBackImage) reviewBackImage.removeAttribute('src');
        if (reviewBackCard) reviewBackCard.hidden = true;

        syncControls();
        updateStepUi();
        setWorkflowStage('upload');
        draw();
        updateFinishState();
        setStatus('', false);

        if (window.UploadKit && typeof window.UploadKit.resetUploaders === 'function') {
          window.UploadKit.resetUploaders();
        } else {
          window.dispatchEvent(new CustomEvent('uploadkit-reset'));
        }

        window.setTimeout(function () {
          isResettingUpload = false;
          updateFinishState();
        }, 100);
      }

      function getSelectedVariant() {
        var selectedVariantNode = document.querySelector('variant-selects [data-selected-variant]');

        if (selectedVariantNode) {
          try {
            return JSON.parse(selectedVariantNode.textContent);
          } catch (error) {}
        }

        return null;
      }

      function getSelectedVariantImage(variant) {
        var selectedVariant = variant || getSelectedVariant();
        var variantSrc =
          selectedVariant && selectedVariant.featured_media && selectedVariant.featured_media.preview_image
            ? selectedVariant.featured_media.preview_image.src
            : selectedVariant && selectedVariant.featured_image
              ? selectedVariant.featured_image.src
              : '';

        if (variantSrc) return variantSrc;

        var activeProductImage = document.querySelector(
          'media-gallery [data-media-id].is-active img, media-gallery .is-active img'
        );
        return activeProductImage ? activeProductImage.currentSrc || activeProductImage.src : shirtSrc;
      }

      function getVariantColor(variant) {
        var values = [];

        if (variant && Array.isArray(variant.options)) values = values.concat(variant.options);
        if (variant && variant.title) values.push(variant.title);
        values = values.join(' ').toLowerCase();
        return values.indexOf('white') !== -1 ? 'white' : 'black';
      }

      function getBackShirtSrc(variant) {
        var color = getVariantColor(variant);
        var matchingFrontSrc = color === 'white' ? whiteFrontSrc : blackFrontSrc;
        var matchingBackSrc = color === 'white' ? whiteBackSrc : blackBackSrc;

        return matchingBackSrc || matchingFrontSrc || getSelectedVariantImage(variant) || shirtSrc;
      }

      function normalizeImageSrc(src) {
        if (src && src.indexOf('//') === 0) return window.location.protocol + src;
        return src || '';
      }

      function updateShirtImage(src, variant) {
        var selectedVariant = variant || getSelectedVariant();
        var nextSrc = normalizeImageSrc(src || getSelectedVariantImage(selectedVariant));
        var nextBackSrc = normalizeImageSrc(getBackShirtSrc(selectedVariant) || nextSrc);
        var requestId;

        if (!nextSrc) return;
        if (
          designer.dataset.claymoreCurrentShirtSrc === nextSrc &&
          designer.dataset.claymoreCurrentBackShirtSrc === nextBackSrc &&
          frontState.shirtImage &&
          backState.shirtImage
        ) {
          return;
        }

        shirtImageRequest += 1;
        requestId = shirtImageRequest;
        Promise.all([loadImage(nextSrc), loadImage(nextBackSrc)])
          .then(function (shirtImages) {
            if (requestId !== shirtImageRequest) return;
            frontState.shirtImage = shirtImages[0];
            backState.shirtImage = shirtImages[1];
            frontState.isDarkGarment = null;
            backState.isDarkGarment = null;
            designer.dataset.claymoreCurrentShirtSrc = nextSrc;
            designer.dataset.claymoreCurrentBackShirtSrc = nextBackSrc;
            draw();
          })
          .catch(function () {
            if (requestId !== shirtImageRequest) return;
            loadImage(nextSrc)
              .then(function (frontImage) {
                if (requestId !== shirtImageRequest) return;
                frontState.shirtImage = frontImage;
                backState.shirtImage = frontImage;
                frontState.isDarkGarment = null;
                backState.isDarkGarment = null;
                designer.dataset.claymoreCurrentShirtSrc = nextSrc;
                designer.dataset.claymoreCurrentBackShirtSrc = nextSrc;
                draw();
                setStatus('The rear blank was unavailable, so the matching shirt blank is being used for back placement.', false);
              })
              .catch(function () {
                if (requestId !== shirtImageRequest) return;
                setStatus('The selected shirt preview could not load. Please refresh and try again.', true);
              });
          });
      }

      function syncControls() {
        if (quickScaleControl) quickScaleControl.value = Math.round(state.scale * 100);
        if (controls.rotation) controls.rotation.value = Math.round(state.rotation);
        if (controls.x) controls.x.value = Math.round(state.x * 100);
        if (controls.y) controls.y.value = Math.round(state.y * 100);
        if (quickScaleValue) {
          quickScaleValue.textContent =
            'Approx. ' + (garmentProfile.maxPrintWidth * state.scale).toFixed(1) + ' in wide';
        }
        if (controlValues.rotation) controlValues.rotation.textContent = Math.round(state.rotation) + '°';
        if (controlValues.x) {
          var horizontalOffset = Math.round(Math.abs(state.x - 0.5) * 100);
          controlValues.x.textContent =
            horizontalOffset <= 2 ? 'Centered' : horizontalOffset + '% ' + (state.x < 0.5 ? 'left' : 'right');
        }
        if (controlValues.y) {
          var verticalOffset = Math.round(Math.abs(state.y - 0.5) * 100);
          controlValues.y.textContent =
            verticalOffset <= 2 ? 'Centered' : verticalOffset + '% ' + (state.y < 0.5 ? 'higher' : 'lower');
        }
      }

      function updateUploadSummary() {
        var lowResolution = state.fileSize > 0 && Math.min(state.sourceWidth || 0, state.sourceHeight || 0) < 800;

        if (uploadName) {
          uploadName.textContent = state.fileName || 'No ' + activeSide + ' artwork selected yet.';
        }
        if (qualityFeedback) {
          if (!state.image) {
            qualityFeedback.textContent = 'Choose the highest-resolution file available.';
          } else if (lowResolution) {
            qualityFeedback.textContent = 'This image may be too small for a sharp print. We will review it before production.';
          } else if (state.sourceWidth && state.sourceHeight) {
            qualityFeedback.textContent =
              state.sourceWidth + ' × ' + state.sourceHeight + ' px preview · Original file retained for printing.';
          } else {
            qualityFeedback.textContent = 'Artwork loaded · Original file retained for printing.';
          }
        }
        if (uploadSummary) {
          uploadSummary.classList.toggle('is-ready', isUploadReady(activeSide));
          uploadSummary.classList.toggle('is-warning', lowResolution);
        }
        if (placementTools) placementTools.hidden = !state.image;
        positionPreviewForViewport();
        syncPlacementLock();
      }

      function updateUploadButtonLabel() {
        var uploadButton;
        var desiredLabel;

        if (!uploadKitBlock) return;
        uploadButton = uploadKitBlock.querySelector('.uploadkit-button');
        if (!uploadButton) return;

        if (uploadButton.getAttribute('aria-hidden') !== 'true') {
          uploadButton.setAttribute('aria-hidden', 'true');
        }
        if (uploadButton.getAttribute('tabindex') !== '-1') {
          uploadButton.setAttribute('tabindex', '-1');
        }
        desiredLabel = (state.image ? 'Replace ' : 'Choose ') + activeSide + ' image';
        if (uploadButton.textContent.trim().toLowerCase() !== desiredLabel.toLowerCase()) {
          uploadButton.textContent = desiredLabel;
        }
      }

      function updateArtworkCards() {
        artworkCards.forEach(function (card) {
          var side = card.dataset.claymoreArtworkCard;
          var cardState = side === 'back' ? backState : frontState;
          var selectButton = designer.querySelector('[data-claymore-artwork-select="' + side + '"]');
          var actionButton = designer.querySelector('[data-claymore-artwork-action="' + side + '"]');
          var thumbnail = artworkThumbnails[side];
          var placeholder = artworkPlaceholders[side];
          var fileLabel = artworkFiles[side];
          var isActive = side === activeSide;
          var imageSrc = cardState.image ? cardState.image.src : '';

          card.hidden = !modeIncludesSide(side);
          card.classList.toggle('is-active', isActive);
          card.classList.toggle('is-ready', Boolean(cardState.image));
          if (selectButton) selectButton.setAttribute('aria-pressed', String(isActive));
          if (actionButton) {
            actionButton.textContent = (cardState.image ? 'Change ' : 'Choose ') + side + ' image';
          }
          if (thumbnail) {
            if (imageSrc && thumbnail.src !== imageSrc) thumbnail.src = imageSrc;
            if (!imageSrc) thumbnail.removeAttribute('src');
            thumbnail.hidden = !imageSrc;
          }
          if (placeholder) placeholder.hidden = Boolean(imageSrc);
          if (fileLabel) {
            fileLabel.textContent = cardState.fileName || 'No image selected';
          }
        });
      }

      function findUploadKitReplacementButton(side) {
        var placementState = side === 'back' ? backState : frontState;
        var thumbnail = findThumbnailForSide(side, placementState, getUploadedThumbnails());
        var container = thumbnail && thumbnail.parentElement;

        while (container && container !== uploadKitBlock) {
          var replacementButton = Array.prototype.slice
            .call(container.querySelectorAll('button, [role="button"], a'))
            .find(function (button) {
              return /change|replace|edit/i.test(
                (button.textContent || '') + ' ' + (button.getAttribute('aria-label') || '')
              );
            });

          if (replacementButton) return replacementButton;
          if (container.classList.contains('uploadkit-thumbnails')) break;
          container = container.parentElement;
        }

        return null;
      }

      function openArtworkChooser(side) {
        var placementState = side === 'back' ? backState : frontState;
        var replacementButton;
        var uploadButton;

        if (!modeIncludesSide(side)) return;
        switchSide(side);
        replacementButton = placementState.image ? findUploadKitReplacementButton(side) : null;
        uploadButton = uploadKitBlock && uploadKitBlock.querySelector('.uploadkit-button');

        if (replacementButton) {
          replacementButton.click();
          return;
        }
        if (uploadButton) {
          uploadButton.click();
          return;
        }
        setStatus('The secure image chooser is still loading. Please try again in a moment.', true);
      }

      function updatePrintModeUi() {
        printModeButtons.forEach(function (button) {
          var isActive = button.dataset.claymorePrintMode === printMode;
          button.classList.toggle('is-active', isActive);
          button.setAttribute('aria-pressed', String(isActive));
        });
      }

      function clearArtworkForPrintMode() {
        if (uploadReadyTimer) {
          window.clearInterval(uploadReadyTimer);
          uploadReadyTimer = null;
        }

        isResettingUpload = true;
        removeHiddenProperties(form);
        frontState = createPlacementState('front');
        backState = createPlacementState('back');
        activeSide = printMode === 'back' ? 'back' : 'front';
        state = activeSide === 'back' ? backState : frontState;
        form.removeAttribute('data-claymore-back-print-variant-id');
        form.removeAttribute('data-claymore-setup-id');
        if (approvalInput) approvalInput.checked = false;
        if (reviewFrontImage) reviewFrontImage.removeAttribute('src');
        if (reviewBackImage) reviewBackImage.removeAttribute('src');
        if (reviewFrontCard) reviewFrontCard.hidden = false;
        if (reviewBackCard) reviewBackCard.hidden = true;

        if (window.UploadKit && typeof window.UploadKit.resetUploaders === 'function') {
          window.UploadKit.resetUploaders();
        } else {
          window.dispatchEvent(new CustomEvent('uploadkit-reset'));
        }

        window.setTimeout(function () {
          isResettingUpload = false;
          updateFinishState();
        }, 100);
      }

      function setPrintMode(nextMode) {
        var supportedModes = ['front', 'back', 'both'];
        var hadArtwork = Boolean(frontState.image || backState.image || getUploadedThumbnails().length);

        if (supportedModes.indexOf(nextMode) === -1 || nextMode === printMode) return;
        if ((nextMode === 'back' || nextMode === 'both') && !backPreviewAvailable) {
          setStatus('A reliable back preview is not available for this garment.', true);
          return;
        }
        if (nextMode === 'both' && !backPrintVariantId) {
          setStatus('The second-side print fee is not configured yet. Please try again shortly.', true);
          return;
        }

        printMode = nextMode;
        if (hadArtwork) clearArtworkForPrintMode();
        else {
          activeSide = printMode === 'back' ? 'back' : 'front';
          state = activeSide === 'back' ? backState : frontState;
        }
        setWorkflowStage('upload');
        updatePrintModeUi();
        updateStepUi();
        updateFinishState();
        setStatus(
          printMode === 'back'
            ? 'Back-only print selected. Choose the artwork for the back of the shirt.'
            : printMode === 'both'
              ? 'Front and back selected. Start with the front artwork, then add the back.'
              : 'Front-only print selected. Choose the artwork for the front of the shirt.',
          false
        );
      }

      function updateStepUi() {
        updatePrintModeUi();
        updateArtworkCards();
        if (placementSideLabel) {
          placementSideLabel.textContent = (activeSide === 'back' ? 'Back' : 'Front') + ' artwork selected';
        }
        if (previewCaption) {
          previewCaption.textContent =
            'The dashed box shows the maximum ' + activeSide + ' print area for ' + garmentProfile.name + '.';
        }
        updateUploadButtonLabel();
        updateUploadSummary();
        syncControls();
        draw();
        updateFinishState();
      }

      function switchSide(side) {
        if (!modeIncludesSide(side)) return;
        activeSide = side === 'back' ? 'back' : 'front';
        state = activeSide === 'back' ? backState : frontState;
        updateStepUi();
        setStatus(
          state.image
            ? 'Your ' + activeSide + ' artwork is ready.'
            : 'Choose the artwork for the ' + activeSide + ' of the shirt.',
          false
        );
      }

      function prepareReview() {
        var selectedVariant = getSelectedVariant();
        var quantityInput = form.querySelector('[name="quantity"]');

        if (modeIncludesSide('front') && frontState.image) {
          generateProof(frontState);
          if (reviewFrontImage && frontState.proofDataUrl) reviewFrontImage.src = frontState.proofDataUrl;
          if (reviewFrontCard) reviewFrontCard.hidden = false;
        } else {
          if (reviewFrontImage) reviewFrontImage.removeAttribute('src');
          if (reviewFrontCard) reviewFrontCard.hidden = true;
        }
        if (modeIncludesSide('back') && backState.image) {
          generateProof(backState);
          if (reviewBackImage && backState.proofDataUrl) reviewBackImage.src = backState.proofDataUrl;
          if (reviewBackCard) reviewBackCard.hidden = false;
        } else {
          if (reviewBackImage) reviewBackImage.removeAttribute('src');
          if (reviewBackCard) reviewBackCard.hidden = true;
        }
        if (reviewProofs) reviewProofs.classList.toggle('is-single', !isTwoSided());

        if (reviewProduct) reviewProduct.textContent = productTitle;
        if (reviewVariant) {
          reviewVariant.textContent = selectedVariant && selectedVariant.title ? selectedVariant.title : 'Selected options';
        }
        if (reviewQuantity) reviewQuantity.textContent = quantityInput ? quantityInput.value || '1' : '1';
        if (reviewSides) {
          reviewSides.textContent =
            printMode === 'both'
              ? 'Front + back (+' + backPrintPrice + ' each)'
              : printMode === 'back'
                ? 'Back only'
                : 'Front only';
        }
      }

      function setWorkflowStage(nextStage) {
        var stages = ['upload', 'review'];
        var nextIndex = stages.indexOf(nextStage);
        var previousStage = workflowStage;

        if (nextIndex === -1) return;
        workflowStage = nextStage;
        modal.dataset.claymoreStage = workflowStage;
        stagePanels.forEach(function (panel) {
          panel.hidden = panel.dataset.claymoreStagePanel !== workflowStage;
        });
        stageButtons.forEach(function (button) {
          var buttonIndex = stages.indexOf(button.dataset.claymoreStageNav);
          var isActive = buttonIndex === nextIndex;
          button.disabled = buttonIndex > nextIndex;
          button.classList.toggle('is-active', isActive);
          button.classList.toggle('is-complete', buttonIndex < nextIndex);
          if (isActive) button.setAttribute('aria-current', 'step');
          else button.removeAttribute('aria-current');
        });
        if (stageBackButton) stageBackButton.hidden = workflowStage === 'upload';
        if (workflowStage === 'review') {
          if (approvalInput && previousStage !== 'review') approvalInput.checked = false;
          prepareReview();
        }
        if (dialog) dialog.scrollTop = 0;
        updateStepUi();
        updateFinishState();
      }

      function draw() {
        var width = canvas.width;
        var height = canvas.height;
        var placementProfile = garmentProfile[state.side] || garmentProfile.front;
        context.clearRect(0, 0, width, height);
        state.printAreaPixels = drawShirt(context, width, height, state, placementProfile);

        if (!state.image) {
          var emptyMessage = 'Choose artwork to begin placement';
          var emptyMessageWidth;

          context.font = '700 24px sans-serif';
          context.textAlign = 'center';
          emptyMessageWidth = context.measureText(emptyMessage).width;
          context.fillStyle = state.isDarkGarment ? 'rgba(16, 17, 20, 0.72)' : 'rgba(255, 255, 255, 0.82)';
          context.fillRect(width / 2 - emptyMessageWidth / 2 - 14, height * 0.5 - 27, emptyMessageWidth + 28, 38);
          context.fillStyle = state.isDarkGarment ? '#ffffff' : 'rgba(16, 17, 20, 0.72)';
          context.fillText(emptyMessage, width / 2, height * 0.5);
        }
      }

      function updateStateFromControls() {
        if (state.isLocked) return;
        state.rotation = controls.rotation ? Number(controls.rotation.value) : state.rotation;
        state.x = controls.x ? Number(controls.x.value) / 100 : state.x;
        state.y = controls.y ? Number(controls.y.value) / 100 : state.y;
        state.scale = clamp(state.scale, 0.2, 1);
        state.rotation = clamp(state.rotation, -30, 30);
        state.x = clamp(state.x, 0.05, 0.95);
        state.y = clamp(state.y, 0.05, 0.95);
        state.proofDataUrl = '';
        syncControls();
        draw();
      }

      function updateArtworkScale(value) {
        if (state.isLocked) return;
        state.scale = clamp(Number(value) / 100, 0.2, 1);
        state.proofDataUrl = '';
        syncControls();
        draw();
      }

      function generateProof(placementState) {
        var previousState = state;

        state = placementState || state;
        draw();
        var proofCanvas = document.createElement('canvas');
        var proofContext = proofCanvas.getContext('2d');
        var proofHeight = Math.round((canvas.height / canvas.width) * PROOF_WIDTH);

        proofCanvas.width = PROOF_WIDTH;
        proofCanvas.height = proofHeight;
        proofContext.drawImage(canvas, 0, 0, proofCanvas.width, proofCanvas.height);

        try {
          state.proofDataUrl = proofCanvas.toDataURL('image/jpeg', PROOF_QUALITY);
        } catch (error) {
          state.proofDataUrl = '';
        }

        state = previousState;
        draw();
      }

      function attachToProductForm() {
        var setupId = 'claymore-' + Date.now() + '-' + Math.random().toString(36).slice(2, 8);
        var frontProofRequested = modeIncludesSide('front') && frontState.image;
        var backProofRequested = modeIncludesSide('back') && backState.image;

        removeHiddenProperties(form);
        setHiddenProperty(
          form,
          'Print location',
          printMode === 'both' ? 'Front + back' : printMode === 'back' ? 'Back only' : 'Front only'
        );
        setHiddenProperty(form, '_Claymore print mode', printMode);

        if (frontProofRequested) {
          generateProof(frontState);
          setHiddenProperty(
            form,
            'Front placement',
            'X ' +
              Math.round(frontState.x * 100) +
              '%, Y ' +
              Math.round(frontState.y * 100) +
              '%, Scale ' +
              Math.round(frontState.scale * 100) +
              '%, Approx. width ' +
              (garmentProfile.maxPrintWidth * frontState.scale).toFixed(1) +
              'in, Rotation ' +
              Math.round(frontState.rotation) +
              'deg'
          );
          setHiddenProperty(form, '_Claymore front placement JSON', formatPlacement(frontState, 'front', garmentProfile));
          setHiddenProperty(form, '_Claymore front source file name', frontState.fileName);
          setHiddenProperty(form, '_Claymore front source file type', frontState.fileType);
          setHiddenProperty(form, '_Claymore front source file size', String(frontState.fileSize || 0));
        }

        if (backProofRequested) {
          generateProof(backState);
          setHiddenProperty(form, 'Back print', isTwoSided() ? 'Second side (+' + backPrintPrice + ')' : 'Back only (included)');
          setHiddenProperty(
            form,
            'Back placement',
            'X ' +
              Math.round(backState.x * 100) +
              '%, Y ' +
              Math.round(backState.y * 100) +
              '%, Scale ' +
              Math.round(backState.scale * 100) +
              '%, Approx. width ' +
              (garmentProfile.maxPrintWidth * backState.scale).toFixed(1) +
              'in, Rotation ' +
              Math.round(backState.rotation) +
              'deg'
          );
          setHiddenProperty(form, '_Claymore back placement JSON', formatPlacement(backState, 'back', garmentProfile));
          setHiddenProperty(form, '_Claymore back source file name', backState.fileName);
          setHiddenProperty(form, '_Claymore back source file type', backState.fileType);
          setHiddenProperty(form, '_Claymore back source file size', String(backState.fileSize || 0));
        }
        if (isTwoSided()) form.dataset.claymoreBackPrintVariantId = backPrintVariantId;
        else form.removeAttribute('data-claymore-back-print-variant-id');
        setHiddenProperty(form, '_Claymore setup ID', setupId);
        setHiddenProperty(form, '_Claymore garment profile', garmentProfile.name);
        form.dataset.claymoreSetupId = setupId;
        setHiddenProperty(form, '_Claymore proof generated', new Date().toISOString());

        if (window.ClaymoreCartProofs) {
          window.ClaymoreCartProofs.save(setupId, {
            front: frontProofRequested ? frontState.proofDataUrl : '',
            back: backProofRequested ? backState.proofDataUrl : '',
          });
        }

        return Promise.all([
          frontProofRequested
            ? uploadProof(frontState.proofDataUrl, 'claymore-front-proof-' + setupId + '.jpg', setupId, 'front')
            : Promise.resolve(''),
          backProofRequested
            ? uploadProof(backState.proofDataUrl, 'claymore-back-proof-' + setupId + '.jpg', setupId, 'back')
            : Promise.resolve(''),
        ]).then(function (proofUrls) {
          if (proofUrls[0]) setHiddenProperty(form, '_Claymore front proof', proofUrls[0]);
          if (proofUrls[1]) setHiddenProperty(form, '_Claymore back proof', proofUrls[1]);
        });
      }

      function loadArtworkFile(file, requestedSide) {
        var side = requestedSide === 'back' ? 'back' : 'front';
        var placementState = side === 'back' ? backState : frontState;

        if (!file || !/^image\/(png|jpeg|webp)$/.test(file.type)) {
          setStatus('Please upload a PNG, JPG, or WEBP image.', true);
          return;
        }

        setStatus('Loading artwork into the placement tool...', false);
        readFileAsDataUrl(file)
          .then(loadImage)
          .then(function (image) {
            var resized = resizeImage(image);
            return loadImage(resized.dataUrl).then(function (resizedImage) {
              placementState.image = resizedImage;
              placementState.fileName = file.name;
              placementState.fileType = file.type;
              placementState.fileSize = file.size;
              placementState.sourceWidth = resized.width;
              placementState.sourceHeight = resized.height;
              placementState.x = DEFAULT_PLACEMENT.x;
              placementState.y = DEFAULT_PLACEMENT.y;
              placementState.scale = DEFAULT_PLACEMENT.scale;
              placementState.rotation = DEFAULT_PLACEMENT.rotation;
              placementState.isLocked = false;
              placementState.proofDataUrl = '';
              placementState.uploadkitThumbnailRequestSrc = '';
              updateArtworkCards();
              if (activeSide === side) {
                updateUploadSummary();
                syncControls();
                draw();
              }
              updateFinishState();
              watchForUploadCompletion();
              setStatus(
                (side === 'back' ? 'Back' : 'Front') +
                  ' artwork loaded. Adjust the placement while the secure upload finishes.',
                false
              );
            });
          })
          .catch(function () {
            setStatus('We could not read that image. Please try another file.', true);
          });
      }

      function findThumbnailForSide(side, placementState, thumbnails) {
        var fileName = (placementState.fileName || '').toLowerCase();
        var fileStem = fileName.replace(/\.[^.]+$/, '');
        var matchingThumbnail;

        if (fileName) {
          matchingThumbnail = thumbnails.find(function (thumbnail) {
            var thumbnailText = [
              thumbnail.alt,
              thumbnail.title,
              thumbnail.getAttribute('data-file-name'),
              thumbnail.getAttribute('data-filename'),
            ]
              .filter(Boolean)
              .join(' ')
              .toLowerCase();
            return thumbnailText.indexOf(fileName) !== -1 || (fileStem && thumbnailText.indexOf(fileStem) !== -1);
          });
        }

        return matchingThumbnail || thumbnails[getUploadIndex(side)];
      }

      function loadArtworkThumbnail() {
        var thumbnails;

        if (isResettingUpload || !uploadKitBlock) return;
        thumbnails = getUploadedThumbnails();

        [
          { side: 'front', placementState: frontState },
          { side: 'back', placementState: backState },
        ].forEach(function (item) {
          var src;
          var thumbnail = findThumbnailForSide(item.side, item.placementState, thumbnails);

          if (!thumbnail) return;
          src = thumbnail.currentSrc || thumbnail.src;
          if (!src) return;
          if (
            item.placementState.uploadkitThumbnailSrc === src ||
            item.placementState.uploadkitThumbnailRequestSrc === src
          ) {
            return;
          }
          item.placementState.uploadkitThumbnailRequestSrc = src;

          loadImage(src)
            .then(function (image) {
              if (item.placementState.uploadkitThumbnailRequestSrc !== src) return;
              item.placementState.image = image;
              item.placementState.isLocked = false;
              item.placementState.uploadkitThumbnailSrc = src;
              item.placementState.uploadkitThumbnailRequestSrc = '';
              if (!item.placementState.fileName) {
                item.placementState.fileName = thumbnail.alt || 'Uploaded ' + item.side + ' artwork';
              }
              if (!item.placementState.sourceWidth || !item.placementState.fileSize) {
                item.placementState.sourceWidth = image.naturalWidth;
                item.placementState.sourceHeight = image.naturalHeight;
              }
              updateArtworkCards();
              if (activeSide === item.side) {
                updateUploadSummary();
                syncControls();
                draw();
              }
              updateFinishState();
            })
            .catch(function () {
              item.placementState.uploadkitThumbnailRequestSrc = '';
            });
        });
      }

      function moveUploadKit() {
        var app = document.querySelector('.uploadkit-app-block');
        var block = app && app.closest('.shopify-app-block');

        if (!block) {
          uploadMoveAttempts += 1;
          if (uploadMoveAttempts < 50) window.setTimeout(moveUploadKit, 100);
          return;
        }

        if (uploadKitBlock === block && block.parentElement === uploadSlot) {
          prepareUploadKitNotes();
          updateFinishState();
          return;
        }

        uploadKitBlock = block;
        uploadKitBlock.classList.add('cm-uploadkit-in-designer');
        uploadSlot.innerHTML = '';
        uploadSlot.appendChild(uploadKitBlock);

        var observer = new MutationObserver(function () {
          prepareUploadKitNotes();
          loadArtworkThumbnail();
          updateUploadButtonLabel();
          updateUploadSummary();
          updateFinishState();
        });
        observer.observe(uploadKitBlock, {
          childList: true,
          subtree: true,
        });
        prepareUploadKitNotes();
        updateUploadButtonLabel();
        updateUploadSummary();
        updateFinishState();
      }

      function openModal(trigger) {
        returnFocus = trigger || document.activeElement;
        updateShirtImage();
        modal.hidden = false;
        document.body.classList.add('cm-designer-modal-open');
        moveUploadKit();
        setWorkflowStage(workflowStage);
        window.setTimeout(function () {
          var artworkAction = modal.querySelector('[data-claymore-artwork-action="' + activeSide + '"]');
          var activeHeading = modal.querySelector('[data-claymore-stage-panel]:not([hidden]) h3');
          (workflowStage === 'upload' && artworkAction ? artworkAction : activeHeading || dialog).focus();
        }, 50);
        setStatus(
          state.image
            ? 'Continue your custom shirt setup.'
            : 'Choose the artwork for the ' + activeSide + ' of the shirt.',
          false
        );
      }

      function closeModal() {
        modal.hidden = true;
        document.body.classList.remove('cm-designer-modal-open');
        if (returnFocus && typeof returnFocus.focus === 'function') returnFocus.focus();
      }

      function interceptAddToCart(event) {
        if (allowSubmit) return;
        var target = event.target;
        var isSubmit = event.type === 'submit' && target === form;
        var clickedSubmit =
          event.type === 'click' && target instanceof Element && target.closest('[type="submit"][name="add"]') === submitButton;

        if (!isSubmit && !clickedSubmit) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        openModal(submitButton);
      }

      window.addEventListener('click', interceptAddToCart, true);
      window.addEventListener('submit', interceptAddToCart, true);
      window.addEventListener(
        'change',
        function (event) {
          var target = event.target;
          var files;
          if (modal.hidden || !(target instanceof HTMLInputElement) || target.type !== 'file') return;
          files = target.files ? Array.prototype.slice.call(target.files) : [];
          if (!files.length) return;
          if (isTwoSided() && files.length > 1) {
            loadArtworkFile(files[0], 'front');
            loadArtworkFile(files[1], 'back');
          } else {
            loadArtworkFile(files[0], activeSide);
          }
        },
        true
      );

      closeButtons.forEach(function (button) {
        button.addEventListener('click', closeModal);
      });

      document.addEventListener('keydown', function (event) {
        var focusable;
        var firstFocusable;
        var lastFocusable;

        if (modal.hidden) return;
        if (event.key === 'Escape') {
          closeModal();
          return;
        }
        if (event.key !== 'Tab') return;
        focusable = Array.prototype.slice.call(
          dialog.querySelectorAll('button:not([disabled]):not([hidden]), input:not([disabled]):not([hidden]), a[href]:not([hidden])')
        ).filter(function (element) {
          return element.offsetParent !== null;
        });
        if (!focusable.length) return;
        firstFocusable = focusable[0];
        lastFocusable = focusable[focusable.length - 1];
        if (event.shiftKey && document.activeElement === firstFocusable) {
          event.preventDefault();
          lastFocusable.focus();
        } else if (!event.shiftKey && document.activeElement === lastFocusable) {
          event.preventDefault();
          firstFocusable.focus();
        }
      });

      Object.keys(controls).forEach(function (key) {
        if (controls[key]) controls[key].addEventListener('input', updateStateFromControls);
      });

      if (quickScaleControl) {
        quickScaleControl.addEventListener('input', function () {
          updateArtworkScale(quickScaleControl.value);
        });
      }

      scaleNudgeButtons.forEach(function (button) {
        button.addEventListener('click', function () {
          if (state.isLocked) return;
          updateArtworkScale(Math.round(state.scale * 100) + Number(button.dataset.claymoreScaleNudge || 0));
        });
      });

      function updatePlacementFromPointer(event) {
        if (!state.image || !state.printAreaPixels) return;
        var rect = canvas.getBoundingClientRect();
        var canvasX = ((event.clientX - rect.left) / rect.width) * canvas.width;
        var canvasY = ((event.clientY - rect.top) / rect.height) * canvas.height;
        var area = state.printAreaPixels;

        state.x = clamp((canvasX - area.x) / area.width, 0.05, 0.95);
        state.y = clamp((canvasY - area.y) / area.height, 0.05, 0.95);
        state.proofDataUrl = '';
        syncControls();
        draw();
      }

      canvas.addEventListener('pointerdown', function (event) {
        if (!state.image || state.isLocked) return;
        state.isDragging = true;
        canvas.setPointerCapture(event.pointerId);
        updatePlacementFromPointer(event);
      });
      canvas.addEventListener('pointermove', function (event) {
        if (state.isDragging) updatePlacementFromPointer(event);
      });
      canvas.addEventListener('pointerup', function (event) {
        state.isDragging = false;
        if (canvas.hasPointerCapture(event.pointerId)) canvas.releasePointerCapture(event.pointerId);
      });
      canvas.addEventListener('pointercancel', function () {
        state.isDragging = false;
      });

      if (placementLockButton) {
        placementLockButton.addEventListener('click', function () {
          if (!state.image) return;
          state.isLocked = !state.isLocked;
          state.isDragging = false;
          syncPlacementLock();
          setStatus(
            state.isLocked
              ? (activeSide === 'back' ? 'Back' : 'Front') + ' placement locked. You can scroll across the preview.'
              : (activeSide === 'back' ? 'Back' : 'Front') + ' placement unlocked. Drag the artwork to adjust it.',
            false
          );
        });
      }

      if (typeof mobilePreviewQuery.addEventListener === 'function') {
        mobilePreviewQuery.addEventListener('change', positionPreviewForViewport);
      } else if (typeof mobilePreviewQuery.addListener === 'function') {
        mobilePreviewQuery.addListener(positionPreviewForViewport);
      }

      if (resetButton) {
        resetButton.addEventListener('click', function () {
          if (state.isLocked) return;
          state.x = DEFAULT_PLACEMENT.x;
          state.y = DEFAULT_PLACEMENT.y;
          state.scale = DEFAULT_PLACEMENT.scale;
          state.rotation = DEFAULT_PLACEMENT.rotation;
          state.proofDataUrl = '';
          syncControls();
          draw();
          setStatus(state.image ? 'Placement reset.' : '', false);
        });
      }

      printModeButtons.forEach(function (button) {
        button.addEventListener('click', function () {
          setPrintMode(button.dataset.claymorePrintMode);
        });
      });

      artworkSelectButtons.forEach(function (button) {
        button.addEventListener('click', function () {
          switchSide(button.dataset.claymoreArtworkSelect);
        });
      });

      artworkActionButtons.forEach(function (button) {
        button.addEventListener('click', function () {
          openArtworkChooser(button.dataset.claymoreArtworkAction);
        });
      });

      stageButtons.forEach(function (button) {
        button.addEventListener('click', function () {
          if (!button.disabled) setWorkflowStage(button.dataset.claymoreStageNav);
        });
      });

      if (stageBackButton) {
        stageBackButton.addEventListener('click', function () {
          setWorkflowStage('upload');
        });
      }

      if (startOverButton) startOverButton.addEventListener('click', resetDesignerForNextItem);
      if (approvalInput) approvalInput.addEventListener('change', updateFinishState);

      if (finishButton) {
        finishButton.addEventListener('click', function () {
          if (isSavingProofs) return;
          if (modeIncludesSide('front') && !frontState.image) {
            setStatus('Choose your front artwork before continuing.', true);
            return;
          }
          if (modeIncludesSide('back') && !backState.image) {
            setStatus('Choose your back artwork before continuing.', true);
            return;
          }
          if (workflowStage === 'upload') {
            setWorkflowStage('review');
            setStatus(
              requiredUploadsReady()
                ? 'Review the proof and confirm the placement.'
                : 'Review the proof while the secure artwork upload finishes.',
              false
            );
            return;
          }
          if (!requiredUploadsReady()) {
            setStatus('Your artwork is still uploading. You can add the shirt when every selected side is ready.', false);
            return;
          }
          if (isTwoSided() && (!backPrintVariantId || !isUploadReady('back'))) {
            setStatus('Complete the back artwork upload before adding both prints to the cart.', true);
            return;
          }
          if (approvalInput && !approvalInput.checked) {
            setStatus('Confirm the placement before adding this shirt to the cart.', true);
            return;
          }

          normalizeCompletedUpload();
          isSavingProofs = true;
          updateFinishState();
          setStatus(
            'Saving your ' +
              (isTwoSided() ? 'front and back placement proofs' : activeSide + ' placement proof') +
              ' for fulfillment...',
            false
          );
          attachToProductForm()
            .then(function () {
              allowSubmit = true;
              closeModal();
              form.requestSubmit(submitButton);
              window.setTimeout(function () {
                allowSubmit = false;
              }, 0);
            })
            .catch(function (error) {
              setStatus(
                error && error.message
                  ? error.message + ' Your shirt has not been added yet; please try again.'
                  : 'The placement proofs could not be saved. Please try again.',
                true
              );
            })
            .finally(function () {
              isSavingProofs = false;
              updateFinishState();
            });
        });
      }

      var formObserver = new MutationObserver(function () {
        updateUploadSummary();
        updateFinishState();
      });
      formObserver.observe(form, { attributes: true, attributeFilter: ['class'] });

      if (
        typeof subscribe === 'function' &&
        typeof PUB_SUB_EVENTS !== 'undefined' &&
        PUB_SUB_EVENTS.variantChange
      ) {
        subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
          var variant = event && event.data ? event.data.variant : null;
          var variantSrc =
            variant && variant.featured_media && variant.featured_media.preview_image
              ? variant.featured_media.preview_image.src
              : variant && variant.featured_image
                ? variant.featured_image.src
                : '';
          updateShirtImage(variantSrc, variant);
        });
      }

      if (
        typeof subscribe === 'function' &&
        typeof PUB_SUB_EVENTS !== 'undefined' &&
        PUB_SUB_EVENTS.cartUpdate
      ) {
        subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
          if (!event || event.source !== 'product-form') return;
          resetDesignerForNextItem();
        });
      }

      syncControls();
      draw();
      updateShirtImage();
      moveUploadKit();
      setWorkflowStage('upload');
      updateFinishState();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initDesigner(document);
    });
  } else {
    initDesigner(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initDesigner(event.target);
  });
})();
